import { QueryClient, dehydrate } from "@tanstack/react-query";
import Ad from "src/components/ads/Ad";
import SContentWrapper from "src/components/contentwrapper/ContentWrapper";
import FilmwebNews from "src/components/filmwebnews/FilmwebNews";
import SSectionTitle from "src/components/kommendefilmer/SectionTitle";
import LatestStreamingReleases from "src/components/lateststreamingreleases/LatestStreamingReleases";
import latestStreamingReleasesQuery from "src/components/lateststreamingreleases/latestStreamingReleasesQuery";
import FinnNoeÅStreameSeo from "src/components/seo/FinnNoeÅStreameSeo";
import StreamingSearchBox from "src/components/streaming/StreamingSearchBox";
import StreamingguideLogo from "src/components/streaming/StreamingguideLogo";
import StreamingContentFinder from "src/components/streaming/findsomethingtostream/StreamingContentFinder";
import { gql } from "graphql-request";
import { buildFilminfoQueryKey, filminfoRequest } from "src/lib/client/useFilminfo";
import AdWrapper from "src/lib/contexts/AdContext";
import { STREAMING_NEWS, filterOtherNews } from "src/lib/groq";
import { StreamingProvider } from "src/lib/movieinfo/movieinfotypes";
import { setDefaultCacheHeaders } from "src/lib/server/cache";
import { filminfoQuery } from "src/lib/server/filminfo";
import { ICommonProps, getServerData, sanityQuery } from "src/lib/server/sanity";
import styled from "src/lib/styles/css";
import type IFilmnytt from "src/lib/types/Filmnytt";
import { type GetServerSideProps } from "next";
import { useOverriddenAdunits } from "src/lib/server/ads";

//#region [Other]getServerSideProps
export const getServerSideProps: GetServerSideProps = getServerData(async (context) => {

    setDefaultCacheHeaders(context);
    const queryClient = new QueryClient();
    const prefetchPopMoviesPromise = queryClient.prefetchQuery({
        queryKey: buildFilminfoQueryKey(latestStreamingReleasesQuery),
        queryFn: filminfoRequest
    });
    const otherNewsPromise = await sanityQuery<IFilmnytt[]>(STREAMING_NEWS);
    const providersPromise = filminfoQuery(QUERY);

    const [otherNews, providers] = await Promise.all([otherNewsPromise, providersPromise, prefetchPopMoviesPromise]);




    return {
        props: {
            news: filterOtherNews(otherNews)?.slice(0, 3) ?? null,
            dehydratedState: dehydrate(queryClient),
            providers: providers?.streamingQuery?.getStreamingProviders ?? null
        }
    };
});
//#endregion

//#region [Props]
export type FinnNoeÅStreameProps = {
    news: IFilmnytt[] | null;
    providers: StreamingProvider[] | null;
} & ICommonProps;
//#endregion

//#region [Component]
export default function FinnNoeÅStreame({ appData, news, providers, adUnits }: FinnNoeÅStreameProps) {
    const finalAdUnits = useOverriddenAdunits(ADS, adUnits);
    return <SContentWrapper as="section">
        <FinnNoeÅStreameSeo />
        <StreamingguideLogo />
        <AdWrapper ads={finalAdUnits}>
            <SSectionTitle $textCenteredMobile>Finn noe å strømme!</SSectionTitle>

            <SElementSpacer>

                <StreamingContentFinder providers={providers!} />

                <Ad targetId="SG3_bottom1_pop" />

                <FilmwebNews articles={news} isStreamingContext={true} />

                <SStreamingSearchBox toolbox={appData.streamingToolbox} />

                <LatestStreamingReleases />

                <Ad targetId="SG3_bottom2_pop" />

            </SElementSpacer>
        </AdWrapper>
    </SContentWrapper>
}
//#endregion

//#region [Styles]

const SElementSpacer = styled.div`
	margin-bottom: 35px;
	display: flex;
	flex-direction: column;
	gap: 35px;
`;

const SStreamingSearchBox = styled(StreamingSearchBox)`
	margin-left: 0;
	margin-right: 0;
`;


//#endregion

const ADS = [
    { auId: '0000000000120274', auW: '100%', auH: '300', targetId: 'SG3_top_pop' },
    { auId: '0000000000120279', auW: '100%', auH: '300', targetId: 'SG3_midt1_pop' },
    { auId: '00000000001202a1', auW: '100%', auH: '300', targetId: 'SG3_midt2_pop' },
    { auId: '00000000001202a5', auW: '100%', auH: '300', targetId: 'SG3_midt3_pop' },
    { auId: '00000000001202a8', auW: '100%', auH: '300', targetId: 'SG3_midt4_pop' },
    { auId: '00000000001202aa', auW: '100%', auH: '300', targetId: 'SG3_bottom1_pop' },
    { auId: '00000000001202ad', auW: '100%', auH: '300', targetId: 'SG3_bottom2_pop' },
];

//#region [Other]
const QUERY = gql`query {
	streamingQuery {
		getStreamingProviders {
			id
			name
			logo
			hasAutomatedImport
		}
	}
}
`;
//#end region